function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.667 9.5a2.5 2.5 0 00-2.5 2.5v15.333a2.5 2.5 0 002.5 2.5H28a2.5 2.5 0 002.5-2.5V12A2.5 2.5 0 0028 9.5H12.667zm0-1.5H28a4 4 0 014 4v15.333a4 4 0 01-4 4H12.667a4 4 0 01-4-4V12a4 4 0 014-4zM26 15.167a1.167 1.167 0 100-2.334 1.167 1.167 0 000 2.334zm0 1.5a2.667 2.667 0 110-5.334 2.667 2.667 0 010 5.334zm5 7.107v2.121l-3.448-3.447a1.404 1.404 0 00-1.986 0l-1.346 1.346a2.5 2.5 0 01-3.536 0l-3.946-3.945a1.5 1.5 0 00-2.121 0l-4.95 4.95v-2.121l3.89-3.89a3 3 0 014.242 0l3.946 3.946a1 1 0 001.414 0l1.347-1.347a2.904 2.904 0 014.107 0L31 23.774zM31 30h-.11l.11-.11V30z",
  fillRule: "nonzero",
  fill: "#000"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _ref);
};

export default SvgComponent;